import styles from "./SpeechDiagnostics.module.css";
import {MyButton, MyText} from "../../../common";
import sectionImage from "../../../../assets/images/pages/ParentsMarathon/section-1-img.png"
import { Col, Grid, Row } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import { ButtonContainer } from "../../../../pages/Articles/style";


export const ButtonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M17.3333 12L21.3333 16M21.3333 16L17.3333 20M21.3333 16H10.6667M28 16C28 17.5759 27.6896 19.1363 27.0866 20.5922C26.4835 22.0481 25.5996 23.371 24.4853 24.4853C23.371 25.5996 22.0481 26.4835 20.5922 27.0866C19.1363 27.6896 17.5759 28 16 28C14.4241 28 12.8637 27.6896 11.4078 27.0866C9.95189 26.4835 8.62902 25.5996 7.51472 24.4853C6.40042 23.371 5.5165 22.0481 4.91345 20.5922C4.31039 19.1363 4 17.5759 4 16C4 12.8174 5.26428 9.76516 7.51472 7.51472C9.76516 5.26428 12.8174 4 16 4C19.1826 4 22.2348 5.26428 24.4853 7.51472C26.7357 9.76516 28 12.8174 28 16Z" stroke="#8C70CE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

export const ButtonSecondIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M12.5078 12.4C12.7899 11.598 13.3468 10.9217 14.0798 10.4909C14.8127 10.0601 15.6745 9.90268 16.5124 10.0464C17.3504 10.1901 18.1104 10.6258 18.6579 11.2762C19.2054 11.9266 19.5051 12.7498 19.5038 13.6C19.5038 16 15.9038 17.2 15.9038 17.2M16 22H16.012M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

export const SpeechDiagnostics = () => {
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const embeddedNavigate = useEmbeddedNavigate();
  const handleGoBack = () => {
    embeddedNavigate('/parents-marathon');
  }

  const handleScrollToAge = () => {
    const element = document.getElementById("select-age");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className={styles.hero} id="hero" aria-label="Марафон запуска речи">
      <div className={styles.container}>
        <div className={styles.content}>
          <Row align="middle" style={{marginBottom: 24}}>
          {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: '#0A033CB2' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="#4C4C4D"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    Назад к марафону
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: '#0A033CB2' }} />
                </ButtonContainer>
                <MyText
                  color="#4C4C4D"
                  size={18}
                  weight={700}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 24 }}
                >
                  Назад к марафону
                </MyText>
              </>
            )}
          </Row>
          <h1 className={styles.title}>
            Диагностика речевого
            <br />
            развития
          </h1>

          <p className={styles.description}>
            Ответьте на вопросы для возраста вашего ребёнка. Это поможет определить уровень речевого развития и понять, нужна ли дополнительная поддержка.
          </p>

          <div className={styles.buttons}>
            <Row
              className={styles.buttonRow}
              onClick={handleScrollToAge}
            >
              <ButtonIcon /> Отмечайте «Да» или «Нет» для каждого пункта
            </Row>
          </div>
        </div>

        <img src={sectionImage} alt="first-section-image"/>
      </div>
    </section>
  );
};